import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import swal from 'sweetalert2'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt } from '@fortawesome/pro-light-svg-icons'

import { Box, Link } from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import usePublicationSpecialDeadline from '@hooks/usePublicationSpecialDeadline'

const confirmDelete = (deleteSpecialDeadline, deleteFn) => {
  const deleteSpecialDeadlinePayload = {
    callbacks: {
      action: deleteFn,
    },
    toastText: 'Special Deadline Deleted',
  }

  swal
    .fire({
      title: 'Delete Special Deadline?',
      text: 'Are you sure? It cannot be recovered.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it.',
      confirmButtonColor: '#DD6B55',
    })
    .then(({ value }) => {
      if (value){
        deleteSpecialDeadline(deleteSpecialDeadlinePayload)
      }
    })
}

const SpecialDeadlineActions = (props) => {
  const { publicationSpecialDeadline } = props

  const {
    callbacks: { deletePublicationSpecialDeadline: deleteFn },
  } = usePublicationSpecialDeadline(publicationSpecialDeadline)

  const {
    callbacks: { deleteSpecialDeadline },
  } = useContext(PageContext)

  return (
    <Box justifyContent="center">
      <Link greyLink onClick={() => confirmDelete(deleteSpecialDeadline, deleteFn)}>
        <FontAwesomeIcon icon={faTrashAlt} />
      </Link>
    </Box>
  )
}

SpecialDeadlineActions.propTypes = {
  publicationSpecialDeadline: PropTypes.object.isRequired,
}

export default SpecialDeadlineActions
